export default __webpack_public_path__ + "static/media/friend-referral.c8c7bad3.png";